/* eslint-disable react/require-default-props */

import React, {createContext, RefObject, useContext} from 'react';
import {
  AccessibilityInfo,
  Alert,
  Animated,
  findNodeHandle,
  InteractionManager,
  Keyboard,
  Modal,
  PanResponder,
  Platform,
  View,
} from 'react-native';
//HIDDEN: CONNAPP-1944
//import {connect} from 'react-redux';
import {
  defer,
  isFunction,
  isNil, //noop
} from 'lodash';

//import {createStructuredSelector} from 'reselect';
import TouchableOpacity from '/component/base/TouchableOpacity';
import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import {withSafeArea} from '/provider/SafeAreaProvider';

//import {closePopover, openPopover} from '/redux/action/popover.action';
//import {isPopoverOpen} from '/redux/selector/popover.selector';
import {styles} from './PopoverProvider.style';

let subscriptions: any = [];
export interface BasePopoverProps {
  triggerRef?: RefObject<any>;
  useModal?: boolean;
  [key: string]: any;
}
export interface PopoverContextType {
  popoverShow: (component: any, props?: BasePopoverProps) => void;
  popoverHide: (callback?: () => void) => void;
}

export const PopoverContext = createContext<PopoverContextType>({
  popoverShow: () => {},
  popoverHide: () => {},
});

interface PopoverProviderProps {
  children?: React.ReactNode;
  onDismiss?: () => void;
  safeAreaInsets: {
    top: number;
    right: number;
    bottom: number;
    left: number;
  };
}

export default ({onDismiss}: any = {}) => {
  class PopoverProvider extends React.PureComponent<PopoverProviderProps> {
    gestureResponder: any;

    popoverAnimating: any;

    popoverComponent: any;

    popoverHeight: any;

    popoverProps: any;

    popoverReady: any;

    popoverReadyResolve: any;

    constructor(...args: any[]) {
      // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
      super(...args);

      this.state = {
        isKeyboardOpened: false,
        measuringContentHeight: true,
        animatedBackdropOpacity: new Animated.Value(0),
        animatedContentHeight: new Animated.Value(0),
        animatedTranslateX: new Animated.Value(Platform.OS === 'web' ? 400 : 0),
        animatedGestureCoordinate: new Animated.ValueXY(),
        popoverState: false,
      };

      this.popoverComponent = null;
      this.popoverProps = {};
      this.popoverHeight = null;
      this.popoverReady = null;
      this.popoverReadyResolve = null;
      this.popoverAnimating = false;

      this.handleKeyboardOpen = this.handleKeyboardOpen.bind(this);
      this.handleKeyboardClose = this.handleKeyboardClose.bind(this);
      this.handleGestureMove = this.handleGestureMove.bind(this);
      this.handleGestureRelease = this.handleGestureRelease.bind(this);
      this.handleLayoutChange = this.handleLayoutChange.bind(this);
      this.handleHidePopover = this.handleHidePopover.bind(this);
      this.handleShowPopover = this.handleShowPopover.bind(this);

      this.gestureResponder = PanResponder.create({
        onStartShouldSetPanResponder: () => false,
        onPanResponderMove: this.handleGestureMove,
        onPanResponderRelease: this.handleGestureRelease,
      });

      // this.openPopover = this.props.openPopover;
      // this.closePopover = this.props.closePopover;
    }

    handleKeyboardOpen() {
      this.setState({isKeyboardOpened: true});
    }

    handleKeyboardClose() {
      this.setState({isKeyboardOpened: false});
    }

    handleGestureMove(evt: any, gestureState: any) {
      // @ts-expect-error TS(2339): Property 'animatedGestureCoordinate' does not exis... Remove this comment to see the full error message
      const {animatedGestureCoordinate} = this.state;

      if (gestureState.dy > 0) {
        Animated.event([null, {dy: animatedGestureCoordinate.y}], {
          useNativeDriver: false,
        })(evt, gestureState);
      }
    }

    handleGestureRelease(evt: any, gestureState: any) {
      // @ts-expect-error TS(2339): Property 'animatedGestureCoordinate' does not exis... Remove this comment to see the full error message
      const {animatedGestureCoordinate} = this.state;

      if (gestureState.dy > this.popoverHeight / 3) {
        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
        this.handleHidePopover();
      } else {
        Animated.spring(animatedGestureCoordinate, {
          useNativeDriver: false,
          toValue: {x: 0, y: 0},
        }).start();
      }
    }

    handleLayoutChange(evt: any) {
      const heightWas = this.popoverHeight;

      const {
        nativeEvent: {
          layout: {height},
        },
      } = evt;

      this.popoverHeight = height;

      const hadHeight = !isNil(heightWas) && heightWas > 0;
      const hasHeight = !isNil(height) && height > 0;
      const heightChanged = heightWas !== height;

      if (!hadHeight && hasHeight) {
        defer(() => this.showPopoverWithAnimation({fast: false}));
      } else if (hadHeight && hasHeight && heightChanged) {
        defer(() => this.showPopoverWithAnimation({fast: true}));
      }

      this.setState({measuringContentHeight: false});
    }

    handleHidePopover(callback?: () => void) {
      // Check animating state to ensure animation functions are not performed while
      // an animation is already in progress.
      if (this.popoverAnimating) {
        return;
      } else {
        this.popoverAnimating = true;
      }

      // @ts-expect-error TS(2339): Property 'animatedBackdropOpacity' does not exist ... Remove this comment to see the full error message
      const {
        animatedBackdropOpacity,
        animatedContentHeight,
        animatedTranslateX,
      } = this.state;

      const animations = [
        Animated.timing(animatedBackdropOpacity, {
          useNativeDriver: false,
          toValue: 0,
          duration: 200,
        }),
        Animated.timing(animatedContentHeight, {
          useNativeDriver: false,
          toValue: 0,
          duration: 200,
        }),
      ];

      if (Platform.OS === 'web') {
        animations.push(
          Animated.timing(animatedTranslateX, {
            useNativeDriver: false,
            toValue: 400,
            duration: 200,
          }),
        );
      }

      Animated.parallel(animations).start(() => {
        if (isFunction(callback)) {
          callback();
        }

        // Rest popover states including animating state.
        this.resetPopoverState();
      });

      // Capture trigger node before resetting it to avoid race condition
      const triggerNodeToFocus = this.openTriggerNode;

      // Set focus after animation completes for all platforms
      if (triggerNodeToFocus) {
        InteractionManager.runAfterInteractions(() => {
          // Add small delay to ensure all UI transitions are complete
          setTimeout(() => {
            try {
              AccessibilityInfo.setAccessibilityFocus(triggerNodeToFocus);
            } catch (error) {
              Alert.alert(
                'Focus Error',
                `Failed to set focus: ${
                  error instanceof Error ? error.message : String(error)
                }`,
              );
            }
          }, 500);
        });
      }
      this.openTriggerNode = null;
    }

    openTriggerNode: number | null = null;

    handleShowPopover(
      popoverComponent: any,
      popoverProps: BasePopoverProps = {},
    ) {
      // store handle to triggering element if available
      if (popoverProps?.triggerRef?.current) {
        const node = findNodeHandle(popoverProps.triggerRef.current);
        this.openTriggerNode = node;
      } else {
        this.openTriggerNode = null;
      }

      this.popoverComponent = popoverComponent;
      this.popoverProps = popoverProps;
      this.popoverReady = new Promise(resolve => {
        this.popoverReadyResolve = resolve;
      });

      // this.openPopover();
      this.forceUpdate();
    }

    showPopoverWithAnimation({fast = false} = {}) {
      // Check animating state to ensure animation functions are not performed while
      // an animation is already in progress.
      if (this.popoverAnimating) {
        return;
      } else {
        this.popoverAnimating = true;
      }

      const {safeAreaInsets} = this.props;

      // @ts-expect-error TS(2339): Property 'isKeyboardOpened' does not exist on type... Remove this comment to see the full error message
      const {
        isKeyboardOpened,
        animatedBackdropOpacity,
        animatedContentHeight,
        animatedTranslateX,
      } = this.state;

      const duration = fast ? 100 : 300;

      const animations = [
        Animated.timing(animatedBackdropOpacity, {
          useNativeDriver: false,
          toValue: 0.25,
          duration,
        }),
        Animated.timing(animatedContentHeight, {
          useNativeDriver: false,
          toValue:
            this.popoverHeight + (isKeyboardOpened ? 0 : safeAreaInsets.bottom),
          duration,
        }),
      ];

      if (Platform.OS === 'web') {
        animations.push(
          Animated.timing(animatedTranslateX, {
            useNativeDriver: false,
            toValue: 0,
            duration,
          }),
        );
      }

      Animated.parallel(animations).start(() => {
        defer(() => {
          if (isFunction(this.popoverReadyResolve)) {
            this.popoverReadyResolve();
          }

          // Rest popover animating state.
          this.popoverAnimating = false;
        });
      });
    }

    resetPopoverState() {
      this.popoverComponent = null;
      this.popoverProps = {};
      this.popoverHeight = null;
      this.popoverReady = null;
      this.popoverReadyResolve = null;
      this.popoverAnimating = false;

      this.setState({
        measuringContentHeight: true,
        animatedBackdropOpacity: new Animated.Value(0),
        animatedContentHeight: new Animated.Value(0),
        animatedTranslateX: new Animated.Value(Platform.OS === 'web' ? 400 : 0),
        animatedGestureCoordinate: new Animated.ValueXY(),
      });
      // this.closePopover();
    }

    // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
    componentDidMount() {
      subscriptions = [
        Keyboard.addListener('keyboardDidShow', this.handleKeyboardOpen),
        Keyboard.addListener('keyboardDidHide', this.handleKeyboardClose),
      ];
    }

    // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
    componentWillUnmount() {
      // @ts-expect-error TS(7006): Parameter 's' implicitly has an 'any' type.
      subscriptions.forEach(s => s?.remove?.());
    }

    renderPopover(extraProps = {}) {
      const PopoverComponent = this.popoverComponent;

      if (PopoverComponent) {
        return (
          <PopoverComponent
            {...(this.popoverProps || {})}
            {...(extraProps || {})}
            popoverReady={this.popoverReady}
            popoverClose={this.handleHidePopover}
            popoverUpdateHeight={() => {
              this.setState({measuringContentHeight: true});
            }}
          />
        );
      } else {
        return null;
      }
    }

    // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
    render() {
      const {children} = this.props;

      const {
        // @ts-expect-error TS(2339): Property 'measuringContentHeight' does not exist o... Remove this comment to see the full error message
        measuringContentHeight,
        // @ts-expect-error TS(2339): Property 'animatedBackdropOpacity' does not exist ... Remove this comment to see the full error message
        animatedBackdropOpacity,
        // @ts-expect-error TS(2339): Property 'animatedContentHeight' does not exist on... Remove this comment to see the full error message
        animatedContentHeight,
        // @ts-expect-error TS(2339): Property 'animatedTranslateX' does not exist on... Remove this comment to see the full error message
        animatedTranslateX,
        // @ts-expect-error TS(2339): Property 'animatedGestureCoordinate' does not exis... Remove this comment to see the full error message
        animatedGestureCoordinate,
      } = this.state;

      const hasPopoverComponent = !isNil(this.popoverComponent);
      const useModal = this.popoverProps?.useModal || false;

      if (useModal) {
        // Render as Modal for true accessibility compliance
        return (
          <PopoverContext.Provider
            value={{
              popoverShow: this.handleShowPopover,
              popoverHide: this.handleHidePopover,
            }}>
            {children}
            {hasPopoverComponent && (
              <Modal
                visible={true}
                transparent={true}
                animationType="slide"
                onRequestClose={() => this.handleHidePopover()}>
                <KeyboardAvoidingView style={styles.base}>
                  <TouchableOpacity
                    accessible={false}
                    style={styles.backdrop}
                    onPress={() => {
                      this.handleHidePopover();
                      if (isFunction(onDismiss)) {
                        onDismiss();
                      }
                    }}
                  />
                  <View
                    style={[
                      styles.contentWrapper,
                      {position: 'absolute', bottom: 0, left: 0, right: 0},
                    ]}>
                    {this.renderPopover({popoverIsShadow: false})}
                  </View>
                </KeyboardAvoidingView>
              </Modal>
            )}
          </PopoverContext.Provider>
        );
      }

      // Original overlay rendering for backward compatibility
      const backdropStyle = [styles.backdrop];
      backdropStyle.push({
        // @ts-expect-error TS(2345): Argument of type '{ opacity: any; }' is not assign... Remove this comment to see the full error message
        opacity: animatedBackdropOpacity,
      });

      const {panHandlers: gestureHandlers} = this.gestureResponder;
      const panStyle = {
        transform: animatedGestureCoordinate.getTranslateTransform(),
      };

      const contentWrapperStyle = [panStyle, styles.contentWrapper];
      if (Platform.OS === 'web') {
        contentWrapperStyle.push({
          transform: [
            ...animatedGestureCoordinate.getTranslateTransform(),
            {translateX: animatedTranslateX},
          ],
        });
      } else {
        contentWrapperStyle.push({
          // @ts-expect-error TS(2345): Argument of type '{ height: any; }' is not assigna... Remove this comment to see the full error message
          height: animatedContentHeight,
        });
      }

      const contentMeasurerStyle = [styles.contentMeasurer];

      return (
        <PopoverContext.Provider
          value={{
            popoverShow: this.handleShowPopover,
            popoverHide: this.handleHidePopover,
          }}>
          {children}
          {hasPopoverComponent && (
            <KeyboardAvoidingView style={styles.base}>
              <Animated.View style={backdropStyle} />
              <TouchableOpacity
                accessible={false}
                style={styles.contentFiller}
                onPress={() => {
                  // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
                  this.handleHidePopover();
                  if (isFunction(onDismiss)) {
                    onDismiss();
                  }
                }}
              />
              <Animated.View style={contentWrapperStyle} {...gestureHandlers}>
                {this.renderPopover({popoverIsShadow: false})}
              </Animated.View>
            </KeyboardAvoidingView>
          )}
          {hasPopoverComponent && measuringContentHeight && (
            <View
              style={contentMeasurerStyle}
              onLayout={this.handleLayoutChange}>
              {this.renderPopover({popoverIsShadow: true})}
            </View>
          )}
        </PopoverContext.Provider>
      );
    }
  }

  return {
    Provider: withSafeArea(PopoverProvider),
    Consumer: PopoverContext.Consumer,
  };
};

// ✅ Export the hook properly
export const usePopover = (): PopoverContextType => {
  const context = useContext(PopoverContext);
  if (!context) {
    throw new Error('usePopover must be used within a PopoverProvider');
  }
  return context;
};
